import { PartnerSocketRepository } from "../repositories/PartnerSocketRepository";
export class ResponseInvitation {
    constructor(private repository: PartnerSocketRepository) {}
	execute(params: ResponseInvitationParams): Promise<void> {
		return this.repository.responseInvitation(params.user_id, params.partner_response);
	}
}

export class ResponseInvitationParams {
	constructor(public user_id: string, public partner_response: boolean) {}
}

